// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"7fb6e0c3","354":"3840a68a","373":"51c29f74","481":"e18d3832","488":"371f7511","499":"1f30357e","595":"9c3b0985","601":"fa2e5f52","746":"39469fc0","757":"ff3dbe15","776":"45cb81d3","883":"9dfedee7"}[chunkId] + ".chunk.js";
};